import React from 'react';
import useI18n from 'i18n/useI18n';
import styled from 'styled-components';
import TimeSelector from './TimeSelector';


const TimeInputsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;

  width: fit-content;
  max-width: 350px;
  width: 100%;

  .time-selector {
    max-width: 162px;
    width: fit-content;
    margin-bottom: 5px;

    &:nth-child(1) {      
      padding-right: 5px;
    }

    &:nth-child(2) {      
      padding-left: 5px;
    }

    #searchInput {
      position: absolute;
    }
  }

  @media( min-width: 768px ) {    
    width: fit-content;
    margin-right: 5px;

    .time-selector {
      width: 160px;
    }
  }
`;

const TimeRangeSelector = ({startProps, endProps}) => {
  const { translate } = useI18n();
  const {
    label: startLabel = translate('Start'),
    value: startValue = null,
    onChange: onChageStart = (value)=>{}
  } = startProps;
  const {
    label: endLabel = translate('End'),
    value: endValue = null,
    onChange: onChageEnd = (value)=>{}
  } = endProps;

  return (
    <TimeInputsContainer>
      <TimeSelector
        label={startLabel}
        value={startValue}
        setValue={onChageStart}
      />
      <TimeSelector
        label={endLabel}
        value={endValue}
        setValue={onChageEnd}
      />
    </TimeInputsContainer>
  )
}
export default TimeRangeSelector;